import React, {Component} from 'react'

const Jeyu = {
  banner: {
    background: '#333',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  },
  thxBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 40,
    color: '#444'
  }
}

export default class Thanks extends Component {
  render() {
    return(
      <div className="container-fluid">
         <div style={Jeyu.banner}>
          <p style={Jeyu.thxBox}>表單已送出! 我們將請專人與您聯絡,謝謝</p>
         </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/View/Thanks.js